<template>
    <div class="container">
        <label><input type="checkbox" @click="selectAll()"> Select all</label>
        <label v-for="(item, key) in data" :key="key" class="row_item">
            <input type="checkbox" v-model="selectedItems" :value="item.id" >
            <div><b>Креслення:</b> {{ item.url }}</div>
            <div>-></div>
            <b>Сертифікати</b>
        </label>
        <div v-if="!data.length">Нема результатів</div>
        <button class="do_btn" @click="action()">Перемістити вибране в категорію "Сертифікати"</button>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        data: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            selectedItems: []
        }
    },
    methods: {
        selectAll() {
            for (const [key, value] of Object.entries(this.data)) {
                this.selectedItems.push(value.id)
            }
        },
        action() {
            axios.post(this.route('api.vector.catalog-move-categories'), {ids: this.selectedItems})
                .then((result) => {
                    location.reload()
                }).catch((error) => {
                    alert('Error!');
                    console.log(error);
                })
        }
    }
}
</script>

<style scoped>
.container {
    padding: 30px;
}
.row_item {
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
}
.do_btn {
    margin-top: 40px;
}
</style>
